import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { initializeAuth, selectIsInitialized, selectAuthLoading } from './store/slices/authSlice';
import { AppRoutes } from './routes';
import './App.css';

function App() {
  const dispatch = useAppDispatch();
  const isInitialized = useAppSelector(selectIsInitialized);
  const isLoading = useAppSelector(selectAuthLoading);

  // Inicializar autenticación al montar la app
  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      dispatch(initializeAuth());
    }

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  // Mostrar loading mientras se verifica la autenticación
  if (!isInitialized || isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          // Opciones por defecto para todos los toasts
          duration: 4000,
          style: {
            background: '#fff',
            color: '#333',
            fontSize: '14px',
            fontWeight: '500',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
          // Estilos específicos por tipo
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#00A6E8', // primary-blue
              secondary: '#fff',
            },
            style: {
              background: '#fff',
              color: '#333',
              border: '2px solid #00A6E8',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#C62828',
              secondary: '#fff',
            },
            style: {
              background: '#fff',
              color: '#333',
              border: '2px solid #C62828',
            },
          },
          loading: {
            iconTheme: {
              primary: '#00A6E8',
              secondary: '#fff',
            },
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;

